import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Check from '@material-ui/icons/Check';
import { FormControl } from '@material-ui/core';
import { LeadsApi, UsersApi } from '../../services/Apis';
import estadosCidades from '../../utils/estados-cidades.json';
import { CustomTextField, CustomLabel, CustomDropdown, CustomButton } from "@tracknme/material-ui";
import { phoneMask } from '../../utils/mask';
import alertMessage from '../../services/alertMessage';
import AlertSnackbar from '../../components/Snackbar/Snackbar';

const useStylesModal = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch'
        }
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        backgroundColor: "#FFFFFF",
        width: '100%',
        height: '100%',
        flexDirection: "column",
        overflow: 'hidden',
        outline: 'none',
        display:'flex', 
        justifyContent:'center', 
        alignItems:'center'
    },
    hedear: {
        backgroundColor: "#4D39E9",
        width: '100%',
        height:80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

function ModalRegiter() {

    const classesModal = useStylesModal();
   
    const [device, setDevices] = useState('1 - 10');
    const [state,setState] = useState('35');
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [city, setCities] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);

    const states = estadosCidades.states.sort(function(a,b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });

    const devices = [
        {
            value: '1 - 10',
            label: '1 - 10'
        }, {
            value: '10 - 100',
            label: '10 - 100'
        }, {
            value: '100 - 1.000',
            label: '100 - 1.000'
        }, {
            value: '1.000 - 10.000',
            label: '1.000 - 10.000'
        }, {
            value: '10.000 - 100.000',
            label: '10.000 - 100.000'
        }, {
            value: '100.000 - 500.000',
            label: '100.000 - 500.000'
        }
    ];

    var cities = estadosCidades.cities.filter(function (el) {
            return el.id <= state
    });

    cities = cities.sort(function(a,b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });

    function changeStateValue(state) {
        setState(state)
        setCities(null)
        cities = estadosCidades.cities.filter(function (el) {
            return el.id <= state
        });

        cities = cities.sort(function(a,b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
    }

    const handleChangeCityValue = (event) => {

        if (event && event.target) {
            if (event.target.outerText) {
                setCities(event.target.outerText);
            }else{
                setCities(null);
            }
        }

    }

    const handleChangeNameValue = ({target}) => {
        const {value} = target;
        setName(value);
    }

    const handleChangeEmailValue = ({target}) => {
        const {value} = target;
        setEmail(value);
    }

    function changeDevicesValue(device) {
        setDevices(device)
    }

    const handleChangePhoneNumberValue = ({target}) => {
        const {value} = target;
        let phone = phoneMask(value);
            setPhoneNumber(phone)
    }

    const checkEmail = () => {
   
        if(validateEmail(email)){
         
          UsersApi.checkLogin(email).then(response => {
    
            setErrorEmail(false)

            if(response.data === 0){
             setErrorEmail(false)
    
            }else{
              alertMessage.showErrorMessage("Esse e-mail já está em uso na plataforma!");
              setErrorEmail(true)
            }
           
            return
          }).catch(error => {
              setErrorEmail(true)
            return
          })
        }else{
          setErrorEmail(true)
          alertMessage.showErrorMessage("E-mail inválido!")
        }
    
    }

    const validationPhoneNumber = () => {
        
        if (phoneNumber && phoneNumber.length < 15) {
            alertMessage.showErrorMessage("Telefone inválido!");
            setErrorPhoneNumber(true)
            return
        }

        setErrorPhoneNumber(false)
    }
    
    const changeButtonValue = async() => {

        if (!validateEmail(email)) {
            alertMessage.showErrorMessage("E-mail inválido!")
            setErrorEmail(true)
            return
        }

        setErrorEmail(false)

        var stateSelected = estadosCidades.states.find((el) => el.value === state);

        let lead = {
            name: name,
            email: email,
            mobile: phoneNumber.replace(/\D/g, ""),
            city: city,
            state: stateSelected.sigla,
            companySize:device
        }
       
        // dispatch(Actions.setLoading(true));

        LeadsApi
            .create(lead)
            .then(response => {
               
            })
            .catch((response,error) => {
                alertMessage.showErrorMessage('Serviço indisponível, tente novamente em alguns segundos...')
                // dispatch(Actions.setLoading(false));
            });

            
            setTimeout(() => {
                setDevices('1 - 10');
                setState('35');
                setPhoneNumber('');
                setCities('');
                setName('');
                setEmail('');
                alertMessage.showSuccessMessage('Cadastro feito com sucesso!')
            }, 1000);
            
    }

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    return (

       
                <div className={classesModal.paper}>

                    <div className={classesModal.hedear}>
                        <CustomLabel
                            id="standard-basic-data-picker"
                            label="Insira seus dados abaixo para criar uma conta gratuita!"
                            color="initial"
                            component="h6"
                            variant="h6"
                            style={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: '#FFFFFF',
                            marginTop: 10
                        }}/>
                    </div>

                    <div
                        style={{
                            flexDirection: "row",
                            
                    }}>
                        <div
                            style={{
                            width: "100%",
                            marginTop: 25,
                            height: 60,
                            flexDirection: "column",
                            marginLeft: 15
                        }}>
                            <FormControl className="m-8 mb-16 flex-1 " disabled={false}>
                                <CustomTextField
                                    label="Nome Completo:"
                                    variant="filled"
                                    value={name}
                                    name="name_1"
                                    onChange={handleChangeNameValue}
                                    placeholder="Insira seu nome"
                                    style={{
                                    width:'35vw'
                                }}/>
                            </FormControl>
                            <FormControl className="m-8 mb-16 flex-1 " disabled={false}>
                                <CustomTextField
                                    label="E-mail:"
                                    variant="filled"
                                    value={email}
                                    name="email_1"
                                    onBlur={() => checkEmail()}  
                                    onKeyPress={event => {if (event.key === 'Enter') {  checkEmail() }}}
                                    onChange={handleChangeEmailValue}
                                    placeholder="Insira seu e-mail comercial"
                                    error={errorEmail}
                                    style={{
                                    width: '35vw'
                                }}/>
                            </FormControl>
                        </div>
                        <div
                            style={{
                            width: "100%",
                            marginTop: 20,
                            height: 60,
                            flexDirection: "column",
                            marginLeft: 15
                        }}>

                            <FormControl className="m-8 mb-16 flex-1 " disabled={false}>
                                <CustomTextField
                                    label="Telefone/Celular:"
                                    value={phoneNumber}
                                    name="phoneNumber_1"
                                    onChange={handleChangePhoneNumberValue}
                                    onBlur={() => validationPhoneNumber()}
                                    variant="filled"
                                    placeholder="Insira seu telefone"
                                    error={errorPhoneNumber}
                                    style={{
                                    width: '35vw'
                                }}/>
                            </FormControl>
                            <FormControl className="m-8 mb-16 flex-1 " disabled={false}>
                                <CustomDropdown
                                    id="state"
                                    label="Quantidade de Rastreadores:"
                                    value={device}
                                    variant="filled"
                                    placeholder="Selecione seu estado"
                                    currencies={devices}
                                    onChange={(event) => changeDevicesValue(event.target.value)}
                                    style={{
                                    width: '35vw',
                                    height: 56
                                }}/>
                            </FormControl>
                        </div>
                        <div
                            style={{
                            width: "100%",
                            marginTop: 20,
                            height: 60,
                            flexDirection: "column",
                            marginLeft: 15
                        }}>
                            <FormControl disabled={false}>
                                <CustomDropdown
                                    id="state"
                                    label="Estado:"
                                    value={state}
                                    variant="filled"
                                    placeholder="Selecione seu estado"
                                    currencies={states}
                                    onChange={(event) => changeStateValue(event.target.value)}
                                    style={{
                                    width: '35vw',
                                    height: 56
                                }}/>
                            </FormControl>
                            <FormControl disabled={false}>
                          
                                 <CustomDropdown
                                    name="city_1"
                                    filter={true}
                                    label="Cidade:"
                                    variant="filled"
                                    placeholder="Selecione sua cidade"
                                    value={city}
                                    currencies={cities}
                                    onChange={handleChangeCityValue}
                                    style={{
                                    width: '35vw',
                                    height: 56
                                }}/> 
                            </FormControl>
                        </div>
                        <div
                            style={{
                            width: "100%",
                            marginTop: 40,
                            height: 60,
                            flexDirection: "column",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FormControl
                                className="m-8 mb-16 flex-1 "
                                disabled={(name  && email && city && phoneNumber && !errorPhoneNumber && !errorEmail)
                                ? false
                                : true}>
                                <CustomButton
                                    id="button"
                                    disabled={(name  && email && city && phoneNumber && !errorPhoneNumber && !errorEmail)
                                    ? false
                                    : true}
                                    onClick={changeButtonValue}
                                    variant="contained"
                                    color="secondary"
                                    label="Cadastrar"
                                    style={{
                                        width: '35vw',
                                        height: 56
                                    }}
                                    endIcon={< Check />}/>
                            </FormControl>
                        </div>
                    </div>
                    <div className="fixedMessage">
                        <AlertSnackbar/>
                    </div>
                </div>

    )
}

export default ModalRegiter;